/* eslint-disable filenames/match-exported */

// eslint-disable-next-line no-undef
type Key = IDBValidKey;

const stores = {
  LANDING_PAGE_IMAGES: "landing_page_images",
  LANDING_PAGE_INFO: "landing_page_info"
};

class IndexedDB {
  private dbName: string;

  private version: number;

  private db: IDBDatabase | null;

  private ready: Promise<IDBDatabase>;

  public stores: Record<string, string>;

  constructor() {
    this.dbName = "culturehq";
    this.version = 2;
    this.db = null;
    this.stores = stores;
    this.ready = this.init(Object.values(this.stores));
  }

  async init(stores: string[] = []): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.version);

      request.onupgradeneeded = (e: IDBVersionChangeEvent) => {
        const db = (e.target as IDBOpenDBRequest).result;
        stores.forEach(store => {
          if (!db.objectStoreNames.contains(store)) {
            db.createObjectStore(store);
          }
        });
      };

      request.onsuccess = (e: Event) => {
        this.db = (e.target as IDBOpenDBRequest).result;
        resolve(this.db);
      };

      request.onerror = (e: Event) => reject((e.target as IDBOpenDBRequest).error);
    });
  }

  async save(store: string, key: Key, value: unknown): Promise<boolean> {
    await this.ready;
    return new Promise((resolve, reject) => {
      if (!this.db) {
        reject("DB not initialized");
        return;
      }
      const tx = this.db.transaction(store, "readwrite");
      tx.objectStore(store).put(value, key);
      tx.oncomplete = () => resolve(true);
      tx.onerror = e => reject((e.target as IDBTransaction).error);
    });
  }

  async get<T = unknown>(store: string, key: Key): Promise<T | undefined> {
    await this.ready;
    return new Promise((resolve, reject) => {
      if (!this.db) {
        reject("DB not initialized");
        return;
      }
      const tx = this.db.transaction(store, "readonly");
      const req = tx.objectStore(store).get(key);
      req.onsuccess = () => resolve(req.result as T | undefined);
      req.onerror = e => reject((e.target as IDBRequest).error);
    });
  }

  async delete(store: string, key: Key): Promise<boolean> {
    await this.ready;
    return new Promise((resolve, reject) => {
      if (!this.db) {
        reject("DB not initialized");
        return;
      }
      const tx = this.db.transaction(store, "readwrite");
      tx.objectStore(store).delete(key);
      tx.oncomplete = () => resolve(true);
      tx.onerror = e => reject((e.target as IDBTransaction).error);
    });
  }
}

const db = new IndexedDB();

export { db as default, stores };
